export const TIMEOUT = 1500;
export const IDLE_INTERVAL = 1800000;
export const KEYDOWN = "keydown";
